import React, { FC } from "react";
import { Select } from "@scuf/common";
import { IOption } from "@scuf/common/dist/components/Select/ISelectProps";
import { IAircraftDetailsFormFields } from "models/aircraftDetails";

interface IAircraftDetailsSelectProps {
  name: string;
  options: Array<IOption>;
  label: string;
  placeholder: string;
  changeOption?: (changedValue: string) => void;
  error: string | undefined;
  value: string;
  selectedMake?: IAircraftDetailsFormFields;
}
export const AircraftDetailsSelect: FC<IAircraftDetailsSelectProps> = ({
  value,
  options,
  label,
  placeholder,
  changeOption,
  error,
  selectedMake,
}) => {
  return (
    <>
      <Select
        className="select-box"
        label={label}
        indicator="required"
        placeholder={placeholder}
        options={options}
        disabled={selectedMake !== undefined && selectedMake.make === ""}
        error={error}
        value={value}
        onChange={(changedValue: string) => {
          if (changeOption !== undefined) {
            changeOption(changedValue);
          }
        }}
      />
    </>
  );
};
